module.exports = __webpack_public_path__ + "img/compact.69753ddc.png";